import React from "react";
import { Linkedin, Instagram, Facebook, Twitter, MessageCircle } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10 min-h-[520px]">
      <div
        className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between gap-8">
          <div className="flex-1 min-w-[200px]">
            <img
              src="/orange-logo.webp"
              alt="Preview Tax Logo"
              width="240"
              height="135"
              decoding="async"
              className="w-[240px] h-[135px] mb-3 object-contain"
            />
            <p className="text-gray-400 text-sm mb-4">
              Your IT & Compliance Partner
            </p>

            <div className="flex-1 min-w-[200px] py-2">
              <h2 className="text-orange-400 text-lg mb-3">Office Address</h2>
              <div className="flex flex-row">
                <p className="text-sm leading-relaxed">
                  J-276, Main Road, Shivaji Marg,
                  <br /> Delhi-110053
                </p>
              </div>
            </div>
          </div>

          <div className="flex-1 min-w-[200px]">
            <h2 className="text-orange-400 text-lg mb-3">Software Development</h2>
            <ul className="space-y-2 text-sm">
              <li>
                Business/Corporate Website Development
              </li>
              <li>
                Custom Software Development(CRM, ERP, HRMS)
              </li>
              <li>
                Web & Mobile App Development
              </li>
              <li>
                AI/ML & Cloud Application Development
              </li>
              <li>
                Maintenance & Hosting Support
              </li>
              <li>
                SEO & Website Optimization
              </li>
              <li>
                UI/UX Design
              </li>
            </ul>
          </div>

          <div className="flex-1 min-w-[200px]">
            <h2 className="text-orange-400 text-lg mb-3">Tax & Compliance</h2>
            <ul className="space-y-2 text-sm">
              <li>
                GST Registration & Amendments
              </li>
              <li>
                GST Return Filing
              </li>
              <li>
                E-Invoicing & E-Way Bill
              </li>
              <li>
                TDS Return Filing
              </li>
              <li>
                Income Tax Return (ITR) Filing
              </li>
              <li>
                Accounting & Bookkeeping
              </li>
              <li>
                Advance Tax & Tax Planning
              </li>
              <li>
                Comprehensive Income Tax & GST Compliance
              </li>
              <li>
                Internal Audit & GST Health Check
              </li>
            </ul>
          </div>

          <div className="flex-1 min-w-[200px]">
            <h2 className="text-orange-400 text-lg mb-3">Registrations & Licensing</h2>
            <ul className="space-y-2 text-sm">
              <li>
                Company Incorporation
              </li>
              <li>
                Partnership & LLP Registration
              </li>
              <li>
                MSME & Udyam Registration
              </li>
              <li>
                FSSAI Registration & License
              </li>
              <li>
                Import Export Code (IEC) Registration
              </li>
              <li>
                Trademark & Brand Protection
              </li>
              <li>
                Shop & Establishment License
              </li>
              <li>
                Professional Tax & Local Registration
              </li>
            </ul>
          </div>

          <div className="flex-1 min-w-[200px]">
            <h2 className="text-orange-400 text-lg mb-3">Quick Links</h2>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/" className="hover:underline">Home</a>
              </li>
              <li>
                <a href="/articles" className="hover:underline">Articles</a>
              </li>
              <li>
                <a href="/tax-calendar" className="hover:underline">Tax Calender</a>
              </li>
              <li>
                <a href="/about" className="hover:underline">About Us</a>
              </li>
              <li>
                <a href="/contact" className="hover:underline">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-700 pt-4 flex flex-wrap justify-between items-center">
          <div className="flex items-center space-x-4">
            <p className="text-orange-400 text-sm">Follow us</p>
            <a
              href="https://www.linkedin.com/company/preview-tax"
              target="_blank"
              rel="noopener noreferrer"
              width={40}
              height={40}
              className="text-blue-600 text-2xl border border-white-900 rounded-full w-10 h-10 flex items-center justify-center bg-white/10"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
            <a
              href="https://www.instagram.com/preview_tax"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-500 text-2xl border border-white-900 rounded-full w-10 h-10 flex items-center justify-center"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://www.facebook.com/previewtax"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white-900 text-2xl border border-white-900 rounded-full w-10 h-10 flex items-center justify-center"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://x.com/preview_tax"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 text-2xl border border-white-900 rounded-full w-10 h-10 flex items-center justify-center"
              aria-label="Twitter"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=919315265493&amp;text=Hello!+Preview+Tax,+I+want+to+know+more+about+your+services"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-500 text-2xl border border-white-900 rounded-full w-10 h-10 flex items-center justify-center"
              aria-label="WhatsApp"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
          </div>

          <div className="text-center text-sm text-gray-400">
            <p>© {new Date().getFullYear()} PreviewTax. All rights reserved.</p>
            <p>support@previewtax.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
